import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { ImportVcardGuestsDialogComponent } from '@tv3/containers/guests/dialogs/import-vcard/import-vcard-guests-dialog.component'
import { Guest } from '@tv3/store/guest/guest.model'

@Injectable()
export class ImportVcardGuestsDialogService {
  constructor(private dialog: MatDialog) {}

  open(data: { guests: Guest[] }) {
    const defaultConfig: MatDialogConfig = {
      width: '950px',
      height: 'auto',
      maxHeight: '95vh',
      panelClass: ['variable-modal'],
      data,
    }

    return this.dialog.open(ImportVcardGuestsDialogComponent, defaultConfig)
  }
}
